import { forwardRef } from "react";
import { Link, LinkProps } from "react-router-dom";
import styles from "./sidebarLink.module.css";

export interface SidebarLinkProps extends LinkProps {
  children: React.ReactNode | React.ReactNode[];
  active: boolean;
}

export const SidebarLink = forwardRef<HTMLAnchorElement, SidebarLinkProps>(
  ({ children, active, className, ...props }, ref) => {
    return (
      <Link
        ref={ref}
        {...props}
        className={`${styles["sidebar-link"]} ${className} ${active ? styles["active"] : ""}`}
      >
        {children}
      </Link>
    );
  },
);
